/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actiontypes from './actiontypes';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { allAccRecNDCDetail } from '../../AccRecNDCDetailAll/store/actions';
import { clearReqAccRecSearchPageDispatch } from '../../ReqAccReceivable/store/actions';
import { dispatchClearARSummaryByQtrAllData } from '../../ARSummaryByQtrAll/store/actions';
import { dispatchClearARSummaryByQtrData } from '../../ARSummaryByQtr/store/actions';
import {
  commonSearchPageOther,
  commonSearchPage,
} from '../../AccountsRevConstants';

export const allAccRecNDCData = (data) => ({
  type: actiontypes.ALL_ACC_REC_NDC_TABLE,
  getAllAccRecNDCList: data,
});

export const qtrAccRecAllFieldValues = (data) => ({
  type: actiontypes.ALL_ACC_REC_FIELD_VALUES,
  getAccRecFieldvalues: data,
});

export const selectedRebatePgm = (val) => {
  return { type: actiontypes.ACC_REBATE_PGM, payload: val };
};

export const selectedRebateName = (val) => {
  return { type: actiontypes.ACC_REBATE_PGM_NAME, payload: val };
};

export const getAccRecNDCAllDetail = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_NDC_ALL_RPC}`, val)
    .then((response) => {
      dispatch(allAccRecNDCData(response.data));
      dispatch(allAccRecNDCDetail(response.data));
    })
    .catch(() => {
      dispatch(allAccRecNDCData([]));
      dispatch(allAccRecNDCDetail([]));
    });
};

export const dispatchClearQtrAccountRecAllData = (val) => {
  return {
    type: actiontypes.QTR_ACCOUNT_REC_ALL_FIELD_CLEAR_REDUX,
    payload: val,
  };
};

export const clearQtrAccountRecAllPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.AccountRecReducer;
  const reduxObj1 = getState()?.sharedState?.ArSummaryQtrAllReducer;
  const reduxObj2 = getState()?.sharedState?.ArSummaryQtrReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass1 = false;
  let changePass2 = false;
  let changePass3 = false;
  let newObj1 = {};
  let newObj2 = {};
  let newObj3 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter((x) => x.navTo === '/reqAccReceivable').length === 0
    ) {
      changePass1 = true;
      newObj1 = {
        ...newObj,
        rebate_list: [],
      };
    }
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/arSummaryByQtrAll' || x.navTo === '/ARSummaryByQtrAll'
      ).length === 0
    ) {
      changePass2 = true;
      newObj2 = {};
    }
    if (updateTabs.filter((x) => x.navTo === '/ARSummaryByQtr').length === 0) {
      changePass3 = true;
      newObj3 = {};
    }
  } else {
    _.mapKeys({ ...commonSearchPageOther, ...commonSearchPage }, (val, key) => {
      newObj1[key] = val;
    });
    changePass1 = true;
    newObj2 = {};
    changePass2 = true;
    newObj3 = {};
    changePass3 = true;
  }
  if (changePass1) {
    dispatch(clearReqAccRecSearchPageDispatch(newObj1));
  }
  if (changePass2) {
    dispatch(dispatchClearARSummaryByQtrAllData(newObj2));
  }
  if (changePass3) {
    dispatch(dispatchClearARSummaryByQtrData(newObj3));
  }
  dispatch(dispatchClearQtrAccountRecAllData({}));
};
